export const GET_COLUMN_METADATA_SUCCESS_COLUMN_METADATA =
    'europa.dataset.GetColumnMetadata.ColumnMetadata';
export const GET_COLUMN_METADATA_FAILURE_UNEXPECTED_FAILURE =
    'europa.dataset.GetColumnMetadata.UnexpectedFailure';
export const UPDATE_ENTITY_DESCRIPTION_FAILURE_ALREADY_UP_TO_DATE =
    'europa.dataset.UpdateEntityDescription.AlreadyUpToDate';
export const UPDATE_ENTITY_DESCRIPTION_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.dataset.UpdateEntityDescription.AssetModificationNotPermitted';
export const UPDATE_ENTITY_DESCRIPTION_SUCCESS_ENTITY_DESCRIPTION_UPDATED =
    'europa.dataset.UpdateEntityDescription.EntityDescriptionUpdated';
export const UPDATE_ENTITY_DESCRIPTION_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.dataset.UpdateEntityDescription.EntityNotFoundOrNotAccessible';
export const UPDATE_ENTITY_DESCRIPTION_FAILURE_UNEXPECTED_FAILURE =
    'europa.dataset.UpdateEntityDescription.UnexpectedFailure';
export const UPDATE_TABLE_DESCRIPTION_FAILURE_ALREADY_UP_TO_DATE =
    'europa.dataset.UpdateTableDescription.AlreadyUpToDate';
export const UPDATE_TABLE_DESCRIPTION_SUCCESS_ASSET_DESCRIPTION_UPDATED =
    'europa.dataset.UpdateTableDescription.AssetDescriptionUpdated';
export const UPDATE_TABLE_DESCRIPTION_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.dataset.UpdateTableDescription.AssetModificationNotPermitted';
export const UPDATE_TABLE_DESCRIPTION_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.dataset.UpdateTableDescription.EntityNotFoundOrNotAccessible';
export const UPDATE_TABLE_DESCRIPTION_FAILURE_UNEXPECTED_FAILURE =
    'europa.dataset.UpdateTableDescription.UnexpectedFailure';
